<template>
  <div class="wrapper-game-table">
    <slot name="item" :user="authUser"></slot>
  </div>
</template>
<script>
  import api from '../../../app/api'
  export default {
    name: 'wrapper-game-table',
    data () {
      return {
        authUser: {}
      }
    },
    mounted () {
      api.user.getAuthUser('',
        (response) => {
          this.authUser = response.data
        }
      )
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/pages/games/WrapperGameTable.vue